import * as Sentry from '@sentry/browser';
import axios from 'axios';
import ajaxUrl from '../../../shared/helpers/ajaxUrl';
import { CartContext } from '../Enum/CartContext';

/**
 * Delete Product services.
 */
export default class DeleteProductService {
  static logSentry = 0;

  /*
   * Delete product by Id
   * */
  public static async deleteProduct(
    referenceId: string,
    context = CartContext.REMOVE_HEADER
  ) {
    const data = {
      action: 'cart',
      data: {
        action: 'remove',
        referenceId,
        context,
      },
    };

    try {
      const response = await axios({
        method: 'DELETE',
        url: ajaxUrl,
        data,
        responseType: 'json',
        headers: {
          'X-Requested-With': 'XMLHttpRequest',
        },
      });
      return response.data;
    } catch (error) {
      DeleteProductService.logError(error);
      return error.response.data;
    }
  }

  static logError(error: Error) {
    if (DeleteProductService.logSentry) {
      Sentry.captureException(`[EMINZA-DELETE-PRODUCT] error: ${error}`);
    } else {
      console.error(`[EMINZA-DELETE-PRODUCT] error: ${error}`);
    }
  }
}
